import { Radar, Volume2, VolumeX, ChevronUp } from "lucide-react";
import { Card } from "../ui/card";
import { useStore } from "@/store/store";
import { useMemo, useState } from "react";
import { Button } from "../ui/button";
import { initAudioContext } from "@/lib/audio";
import { useTheme } from "@/components/theme-provider";

export const TrackingLayer = () => {
  const dronesCount = useStore(useMemo(() => (state) => state.drones.size, []));
  const { theme } = useTheme();
  const alertsEnabled = useStore((state) => state.alertsEnabled);
  const toggleAlerts = useStore((state) => state.toggleAlerts);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleAlerts = () => {
    // Initialize audio context on first toggle
    initAudioContext();
    toggleAlerts();
  };

  return (
    <Card
      className={`border transition-all duration-200 ${
        isExpanded ? "w-80" : "w-12 p-0 py-2"
      } ${
        theme === "dark" 
          ? "bg-gray-900/95 text-white border-gray-700" 
          : "bg-white/95 text-black border-gray-200"
      }`}
    >
      {!isExpanded ? (
        <div
          className="flex items-center justify-center p-0 cursor-pointer hover:bg-gray-800/20 dark:hover:bg-gray-100/20 transition-colors relative group"
          onClick={() => setIsExpanded(true)}
          title={`Airspace Summary - ${dronesCount} drones`}
        >
          <Radar className="h-5 w-5" />
          {dronesCount > 0 && (
            <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
              {dronesCount}
            </div>
          )}
        </div>
      ) : (
        <>
          <div
            className="flex items-center justify-between p-3 cursor-pointer hover:bg-gray-800/20 dark:hover:bg-gray-100/20 transition-colors"
            onClick={() => setIsExpanded(false)}
          >
            <div className="flex items-center gap-2">
              <Radar className="h-4 w-4" />
              <h3 className="font-medium text-sm">Airspace Summary</h3>
            </div>
            <div className="flex items-center gap-1">
              <Button
                variant="ghost"
                size="icon"
                className="h-6 w-6"
                onClick={(e) => {
                  e.stopPropagation();
                  handleToggleAlerts();
                }}
              >
                {alertsEnabled ? (
                  <Volume2 className="h-3 w-3" />
                ) : (
                  <VolumeX className="h-3 w-3" />
                )}
              </Button>
              <ChevronUp className="h-4 w-4" />
            </div>
          </div>

          <div className="px-3 pb-3 space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span>Active Drones</span>
              <span className="font-medium">{dronesCount}</span>
            </div>
          </div>
        </>
      )}
    </Card>
  );
};
